import styled from "styled-components";
import {
  UnderlineLink,
  PrimaryButtonComponent,
  DisplayFlex
} from "../../../../../../../../CommonComponents/commonStyles";

export const PopContainer = styled.div`
  text-align: center;
`;
export const PopupHeading = styled.div`
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  padding: 30px 0 15px 0;
  line-height: ${props => props.theme.lineHeight.popUpHeading};
  margin-left: 43px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: flex;
    justify-content: center;
  }
`;

export const PopupContentContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  margin: 0 30px 20px 30px; 
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    margin: 0 20px 10px 20px; 
  }
`;

export const PopupWrap = styled.div`
  position: fixed;
  background: #ffffff;
  width: ${props => props.width};
  // height: ${props => props.height};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: ${props => props.mwidth};
    // height: ${props => props.mheight};
  }
`;

export const PopupWrapAutofill = styled(PopupWrap)`
  width: 565px;
  height: 347px
`

export const PopupContentLine1 = styled.div`
  padding-bottom: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 20px;
  }
`;

export const PopupContentLine1Align = styled(PopupContentLine1)`
width: ${props => props.width};
padding-bottom: ${props => props.paddingBottom};
`;

export const DisplayFlexCenter = styled(DisplayFlex)`
  justify-content: center;
`;

export const IconWrap = styled.div`
  float: right;
  margin-top: 33px;
  margin-right: 26px;
  cursor: pointer;
`;

export const PrimaryButton = styled(PrimaryButtonComponent)`
  border-radius: 0;
  border: none !important;
  width: auto;
  width: 150px;
  height: 50px !important;
  margin-bottom: 10px;
  font-size: ${props => props.theme.fontSize.primary};
  font-family:  ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  line-height: ${props => props.theme.lineHeight.subHeading};
  border: none;
  @media only screen and (min-width: 320px) and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary} !important;
    width: 150px;
  }
`;

export const Underlinelink = styled(UnderlineLink)`
  letter-spacing: 0px;
  display: block;
  margin-bottom: 30px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue}
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
`;

export const PopContainerWrap = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
`;
